import { createAction } from 'redux-act';
// Get Employee Details By Pay Days action
const getEmployeeDetailsByPayDaysRequest = createAction('GET_EMPLOYEE_DETAILS_BY_PAY_DAYS_REQUEST', data => data);
const getEmployeeDetailsByPayDaysSuccess = createAction('GET_EMPLOYEE_DETAILS_BY_PAY_DAYS_SUCCESS', data => data);
const getEmployeeDetailsByPayDaysError = createAction('GET_EMPLOYEE_DETAILS_BY_PAY_DAYS_ERROR');

// Get Attendance Status action
const getAttendanceStatusRequest = createAction('GET_ATTENDANCE_STATUS_REQUEST', data => data);
const getAttendanceStatusSuccess = createAction('GET_ATTENDANCE_STATUS_SUCCESS', data => data);
const getAttendanceStatusError = createAction('GET_ATTENDANCE_STATUS_ERROR');

// Update Attendance Tracking
const updateAttendanceTrackingRequest = createAction('UPDATE_ATTENDANCE_TRACKING_REQUEST', data => data);
const updateAttendanceTrackingSuccess = createAction('UPDATE_ATTENDANCE_TRACKING_SUCCESS', data => data);
const updateAttendanceTrackingError = createAction('UPDATE_ATTENDANCE_TRACKING_ERROR');

// Add Earnings
const addEarningsRequest = createAction('ADD_EARNINGS_REQUEST', data => data);
const addEarningsSuccess = createAction('ADD_EARNINGS_SUCCESS', data => data);
const addEarningsError = createAction('ADD_EARNINGS_ERROR');

// Update Earnings
const updateEarningsRequest = createAction('UPDATE_EARNINGS_REQUEST', data => data);
const updateEarningsSuccess = createAction('UPDATE_EARNINGS_SUCCESS', data => data);
const updateEarningsError = createAction('UPDATE_EARNINGS_ERROR');

// Get Earnings
const getEarningsRequest = createAction('GET_EARNINGS_REQUEST', data => data);
const getEarningsSuccess = createAction('GET_EARNINGS_SUCCESS', data => data);
const getEarningsError = createAction('GET_EARNINGS_ERROR');

// add Deductions
const addDeductionsRequest = createAction('ADD_DEDUCTIONS_REQUEST', data => data);
const addDeductionsSuccess = createAction('ADD_DEDUCTIONS_SUCCESS', data => data);
const addDeductionsError = createAction('ADD_DEDUCTIONS_ERROR');

// update Deductions
const updateDeductionsRequest = createAction('UPDATE_DEDUCTIONS_REQUEST', data => data);
const updateDeductionsSuccess = createAction('UPDATE_DEDUCTIONS_SUCCESS', data => data);
const updateDeductionsError = createAction('UPDATE_DEDUCTIONS_ERROR');

// Get Deductions
const getDeductionsRequest = createAction('GET_DEDUCTIONS_REQUEST', data => data);
const getDeductionsSuccess = createAction('GET_DEDUCTIONS_SUCCESS', data => data);
const getDeductionsError = createAction('GET_DEDUCTIONS_ERROR');

// Get Tax Slabs
const addTaxSlabsRequest = createAction('GET_TAX_SLABS_REQUEST', data => data);
const addTaxSlabsSuccess = createAction('GET_TAX_SLABS_SUCCESS', data => data);
const addTaxSlabsError = createAction('GET_TAX_SLABS_ERROR');

// Add Earning Types
const addEarningTypesRequest = createAction('ADD_EARNING_TYPES_REQUEST', data => data);
const addEarningTypesSuccess = createAction('ADD_EARNING_TYPES_SUCCESS', data => data);
const addEarningTypesError = createAction('ADD_EARNING_TYPES_ERROR');

// Update Earning Types
const updateEarningTypesRequest = createAction('UPDATE_EARNING_TYPES_REQUEST', data => data);
const updateEarningTypesSuccess = createAction('UPDATE_EARNING_TYPES_SUCCESS', data => data);
const updateEarningTypesError = createAction('UPDATE_EARNING_TYPES_ERROR');

// Get Earning Type
const getEarningTypeRequest = createAction('GET_EARNING_TYPE_REQUEST', data => data);
const getEarningTypeSuccess = createAction('GET_EARNING_TYPE_SUCCESS', data => data);
const getEarningTypeError = createAction('GET_EARNING_TYPE_ERROR');


// Get All Earning Type
const getAllEarningTypeRequest = createAction('GET_ALL_EARNING_TYPE_REQUEST', data => data);
const getAllEarningTypeSuccess = createAction('GET_ALL_EARNING_TYPE_SUCCESS', data => data);
const getAllEarningTypeError = createAction('GET_ALL_EARNING_TYPE_ERROR');

const getEarningTypeByIdRequest = createAction('GET_EARNING_TYPE_BY_ID_REQUEST', data => data);
const getEarningTypeByIdSuccess = createAction('GET_EARNING_TYPE_BY_ID_SUCCESS', data => data);
const getEarningTypeByIdError = createAction('GET_EARNING_TYPE_BY_ID_ERROR');


// Add Deduction Types
const addDeductionTypesRequest = createAction('ADD_DEDUCTION_TYPES_REQUEST', data => data);
const addDeductionTypesSuccess = createAction('ADD_DEDUCTION_TYPES_SUCCESS', data => data);
const addDeductionTypesError = createAction('ADD_DEDUCTION_TYPES_ERROR');

// Update Deduction Types
const updateDeductionTypesRequest = createAction('UPDATE_DEDUCTION_TYPES_REQUEST', data => data);
const updateDeductionTypesSuccess = createAction('UPDATE_DEDUCTION_TYPES_SUCCESS', data => data);
const updateDeductionTypesError = createAction('UPDATE_DEDUCTION_TYPES_ERROR');

// Get Deduction Type
const getDeductionTypeRequest = createAction('GET_DEDUCTION_TYPE_REQUEST', data => data);
const getDeductionTypeSuccess = createAction('GET_DEDUCTION_TYPE_SUCCESS', data => data);
const getDeductionTypeError = createAction('GET_DEDUCTION_TYPE_ERROR');

// Get All Earning Type
const getAllDeductionTypeRequest = createAction('GET_ALL_DEDUCTION_TYPE_REQUEST', data => data);
const getAllDeductionTypeSuccess = createAction('GET_ALL_DEDUCTION_TYPE_SUCCESS', data => data);
const getAllDeductionTypeError = createAction('GET_ALL_DEDUCTION_TYPE_ERROR');

// Get Deduction Type By Id action
const getDeductionTypeByIdRequest = createAction('GET_DEDUCTION_TYPE_BY_ID_REQUEST', data => data);
const getDeductionTypeByIdSuccess = createAction('GET_DEDUCTION_TYPE_BY_ID_SUCCESS', data => data);
const getDeductionTypeByIdError = createAction('GET_DEDUCTION_TYPE_BY_ID_ERROR');

//generate Salary Template action
const generateSalaryTemplateRequest = createAction('GENERATE_SALARY_TEMPLATE_REQUEST', data => data);
const generateSalaryTemplateSuccess = createAction('GENERATE_SALARY_TEMPLATE_SUCCESS', data => data);
const generateSalaryTemplateError = createAction('GENERATE_SALARY_TEMPLATE_ERROR');

//save Salary Template action
const saveSalaryTemplateRequest = createAction('SAVE_SALARY_TEMPLATE_REQUEST', data => data);
const saveSalaryTemplateSuccess = createAction('SAVE_SALARY_TEMPLATE_SUCCESS', data => data);
const saveSalaryTemplateError = createAction('SAVE_SALARY_TEMPLATE_ERROR');

//get All Salary Template action
const getAllSalaryTemplateRequest = createAction('GET_ALL_SALARY_TEMPLATE_REQUEST', data => data);
const getAllSalaryTemplateSuccess = createAction('GET_ALL_SALARY_TEMPLATE_SUCCESS', data => data);
const getAllSalaryTemplateError = createAction('GET_ALL_SALARY_TEMPLATE_ERROR');

//get Salary Template action
const getSalaryTemplateRequest = createAction('GET_SALARY_TEMPLATE_REQUEST', data => data);
const getSalaryTemplateSuccess = createAction('GET_SALARY_TEMPLATE_SUCCESS', data => data);
const getSalaryTemplateError = createAction('GET_SALARY_TEMPLATE_ERROR');

//Update Salary Template action
const updateSalaryTemplateRequest = createAction('UPDATE_SALARY_TEMPLATE_REQUEST', data => data);
const updateSalaryTemplateSuccess = createAction('UPDATE_SALARY_TEMPLATE_SUCCESS', data => data);
const updateSalaryTemplateError = createAction('UPDATE_SALARY_TEMPLATE_ERROR');

//Get Salary Template action
const getSalaryTemplateByIdRequest = createAction('GET_SALARY_TEMPLATE_BY_ID_REQUEST', data => data);
const getSalaryTemplateByIdSuccess = createAction('GET_SALARY_TEMPLATE_BY_ID_SUCCESS', data => data);
const getSalaryTemplateByIdError = createAction('GET_SALARY_TEMPLATE_BY_ID_ERROR');

//get All Earning action
const getAllEarningRequest = createAction('GET_ALL_EARNING_REQUEST', data => data);
const getAllEarningSuccess = createAction('GET_ALL_EARNING_SUCCESS', data => data);
const getAllEarningError = createAction('GET_ALL_EARNING_ERROR');

//get All deduction action
const getAllDeductionRequest = createAction('GET_ALL_DEDUCTION_REQUEST', data => data);
const getAllDeductionSuccess = createAction('GET_ALL_DEDUCTION_SUCCESS', data => data);
const getAllDeductionError = createAction('GET_ALL_DEDUCTION_ERROR');

//calculate Ctc action
const calculateCtcRequest = createAction('CALCULATE_CTC_REQUEST', data => data);
const calculateCtcSuccess = createAction('CALCULATE_CTC_SUCCESS', data => data);
const calculateCtcError = createAction('CALCULATE_CTC_ERROR');

//Add Arrears action
const addArrearsRequest = createAction('ADD_ARREARS_REQUEST', data => data);
const addArrearsSuccess = createAction('ADD_ARREARS_SUCCESS', data => data);
const addArrearsError = createAction('ADD_ARREARS_ERROR');

//Get Arrears action
const getArrearsRequest = createAction('GET_ARREARS_REQUEST', data => data);
const getArrearsSuccess = createAction('GET_ARREARS_SUCCESS', data => data);
const getArrearsError = createAction('GET_ARREARS_ERROR');

//Add Employee Salary action
const addEmployeeSalaryRequest = createAction('ADD_EMPLOYEE_SALARY_REQUEST', data => data);
const addEmployeeSalarySuccess = createAction('ADD_EMPLOYEE_SALARY_SUCCESS', data => data);
const addEmployeeSalaryError = createAction('ADD_EMPLOYEE_SALARY_ERROR');

//Get Employee Salary action
const getEmployeeSalaryRequest = createAction('GET_EMPLOYEE_SALARY_REQUEST', data => data);
const getEmployeeSalarySuccess = createAction('GET_EMPLOYEE_SALARY_SUCCESS', data => data);
const getEmployeeSalaryError = createAction('GET_EMPLOYEE_SALARY_ERROR');

//Update Employee Salary action
const updateEmployeeSalaryRequest = createAction('Update_EMPLOYEE_SALARY_REQUEST', data => data);
const updateEmployeeSalarySuccess = createAction('Update_EMPLOYEE_SALARY_SUCCESS', data => data);
const updateEmployeeSalaryError = createAction('Update_EMPLOYEE_SALARY_ERROR');

//Update Employee Salary action
const getAllEmployeeAssignStatusRequest = createAction('GET_ALL_EMPLOYEE_ASSIGN_STATUS_REQUEST', data => data);
const getAllEmployeeAssignStatusSuccess = createAction('GET_ALL_EMPLOYEE_ASSIGN_STATUS_SUCCESS', data => data);
const getAllEmployeeAssignStatusError = createAction('GET_ALL_EMPLOYEE_ASSIGN_STATUS_ERROR');

//Add PayRun action
const addPayRunRequest = createAction('ADD_PAY_RUN_REQUEST', data => data);
const addPayRunSuccess = createAction('ADD_PAY_RUN_SUCCESS', data => data);
const addPayRunError = createAction('ADD_PAY_RUN_ERROR');

//Add  Pay Schedule action
const addPayScheduleRequest = createAction('ADD_PAY_SCHEDULE_REQUEST', data => data);
const addPayScheduleSuccess = createAction('ADD_PAY_SCHEDULE_SUCCESS', data => data);
const addPayScheduleError = createAction('ADD_PAY_SCHEDULE_ERROR');

//Update pay Schedule action
const updatePayScheduleRequest = createAction('UPDATE_PAY_SCHEDULE_REQUEST', data => data);
const updatePayScheduleSuccess = createAction('UPDATE_PAY_SCHEDULE_SUCCESS', data => data);
const updatePayScheduleError = createAction('UPDATE_PAY_SCHEDULE_ERROR');

//Upcoming Payrolls action
const upcomingPayrollsRequest = createAction('UPCOMING_PAYROLLS_REQUEST', data => data);
const upcomingPayrollsSuccess = createAction('UPCOMING_PAYROLLS_SUCCESS', data => data);
const upcomingPayrollsError = createAction('UPCOMING_PAYROLLS_ERROR');

//Pay Roll Notification action
const payRollNotificationRequest = createAction('PAY_ROLL_NOTIFICATION_REQUEST', data => data);
const payRollNotificationSuccess = createAction('PAY_ROLL_NOTIFICATION_SUCCESS', data => data);
const payRollNotificationError = createAction('PAY_ROLL_NOTIFICATION_ERROR');

//Get Pay Run action
const getPayRunRequest = createAction('GET_PAY_RUN_REQUEST', data => data);
const getPayRunSuccess = createAction('GET_PAY_RUN_SUCCESS', data => data);
const getPayRunError = createAction('GET_PAY_RUN_ERROR');

//Get Pay Run Dashboard Data action
const getPayRunDashboardDataRequest = createAction('GET_PAY_RUN_DASHBOARD_DATA_REQUEST', data => data);
const getPayRunDashboardDataSuccess = createAction('GET_PAY_RUN_DASHBOARD_DATA_SUCCESS', data => data);
const getPayRunDashboardDataError = createAction('GET_PAY_RUN_DASHBOARD_DATA_ERROR');

//Get Pay Run History action
const getPayRunHistoryRequest = createAction('GET_PAY_RUN_HISTORY_REQUEST', data => data);
const getPayRunHistorySuccess = createAction('GET_PAY_RUN_HISTORY_SUCCESS', data => data);
const getPayRunHistoryError = createAction('GET_PAY_RUN_HISTORY_ERROR');

// Approve Payroll action
const approvePayrollRequest = createAction('APPROVE_PAYROLL_REQUEST', data => data);
const approvePayrollSuccess = createAction('APPROVE_PAYROLL_SUCCESS', data => data);
const approvePayrollError = createAction('APPROVE_PAYROLL_ERROR');

//Add Tax Slab action
const addTaxSlabRequest = createAction('ADD_TAX_SLAB_REQUEST', data => data);
const addTaxSlabSuccess = createAction('ADD_TAX_SLAB_SUCCESS', data => data);
const addTaxSlabError = createAction('ADD_TAX_SLAB_ERROR');

// Update Tex Slab action
const updateTaxSlabRequest = createAction('UPDATE_TAX_SLAB_REQUEST', data => data);
const updateTaxSlabSuccess = createAction('UPDATE_TAX_SLAB_SUCCESS', data => data);
const updateTaxSlabError = createAction('UPDATE_TAX_SLAB_ERROR');

// Get Tex Slab action
const getTaxSlabRequest = createAction('GET_TAX_SLAB_REQUEST', data => data);
const getTaxSlabSuccess = createAction('GET_TAX_SLAB_SUCCESS', data => data);
const getTaxSlabError = createAction('GET_TAX_SLAB_ERROR');

// Get All Tex Slab action
const getAllTaxSlabRequest = createAction('GET_ALL_TAX_SLAB_REQUEST', data => data);
const getAllTaxSlabSuccess = createAction('GET_ALL_TAX_SLAB_SUCCESS', data => data);
const getAllTaxSlabError = createAction('GET_ALL_TAX_SLAB_ERROR');

//  Delete Tex Slab action
const deleteTaxSlabRequest = createAction('DELETE_TAX_SLAB_REQUEST', data => data);
const deleteTaxSlabSuccess = createAction('DELETE_TAX_SLAB_SUCCESS', data => data);
const deleteTaxSlabError = createAction('DELETE_TAX_SLAB_ERROR');

//  Add Employee Investment action
const addEmployeeInvestmentRequest = createAction('ADD_EMPLOYEE_INVESTMENT_REQUEST', data => data);
const addEmployeeInvestmentSuccess = createAction('ADD_EMPLOYEE_INVESTMENT_SUCCESS', data => data);
const addEmployeeInvestmentError = createAction('ADD_EMPLOYEE_INVESTMENT_ERROR');

//  Get Employee Investment action
const getEmployeeInvestmentRequest = createAction('GET_EMPLOYEE_INVESTMENT_REQUEST', data => data);
const getEmployeeInvestmentSuccess = createAction('GET_EMPLOYEE_INVESTMENT_SUCCESS', data => data);
const getEmployeeInvestmentError = createAction('GET_EMPLOYEE_INVESTMENT_ERROR');

//  Update Employee Investment action
const updateEmployeeInvestmentRequest = createAction('UPDATE_EMPLOYEE_INVESTMENT_REQUEST', data => data);
const updateEmployeeInvestmentSuccess = createAction('UPDATE_EMPLOYEE_INVESTMENT_SUCCESS', data => data);
const updateEmployeeInvestmentError = createAction('UPDATE_EMPLOYEE_INVESTMENT_ERROR');

/*delete Employee Investment action */
const deleteEmployeeInvestmentRequest = createAction('DELETE_EMPLOYEE_INVESTMENT_REQUEST', data => data);
const deleteEmployeeInvestmentSuccess = createAction('DELETE_EMPLOYEE_INVESTMENT_SUCCESS', data => data);
const deleteEmployeeInvestmentError = createAction('DELETE_EMPLOYEE_INVESTMENT_ERROR');

/*Add Investment Category Action */
const addInvestmentCategoryRequest = createAction('ADD_INVESTMENT_CATEGORY_REQUEST', data => data);
const addInvestmentCategorySuccess = createAction('ADD_INVESTMENT_CATEGORY_SUCCESS', data => data);
const addInvestmentCategoryError = createAction('ADD_INVESTMENT_CATEGORY_ERROR');

/*Update Investment Category Action */
const updateInvestmentCategoryRequest = createAction('UPDATE_INVESTMENT_CATEGORY_REQUEST', data => data);
const updateInvestmentCategorySuccess = createAction('UPDATE_INVESTMENT_CATEGORY_SUCCESS', data => data);
const updateInvestmentCategoryError = createAction('UPDATE_INVESTMENT_CATEGORY_ERROR');

/*Get Investment Category Action */
const getInvestmentCategoryRequest = createAction('GET_INVESTMENT_CATEGORY_REQUEST', data => data);
const getInvestmentCategorySuccess = createAction('GET_INVESTMENT_CATEGORY_SUCCESS', data => data);
const getInvestmentCategoryError = createAction('GET_INVESTMENT_CATEGORY_ERROR');

/*Get All Investment Category Action */
const getAllInvestmentCategoryRequest = createAction('GET_All_INVESTMENT_CATEGORY_REQUEST', data => data);
const getAllInvestmentCategorySuccess = createAction('GET_All_INVESTMENT_CATEGORY_SUCCESS', data => data);
const getAllInvestmentCategoryError = createAction('GET_All_INVESTMENT_CATEGORY_ERROR');


/*Get Delete Investment Category Action */
const deleteInvestmentCategoryRequest = createAction('DELETE_INVESTMENT_CATEGORY_REQUEST', data => data);
const deleteInvestmentCategorySuccess = createAction('DELETE_INVESTMENT_CATEGORY_SUCCESS', data => data);
const deleteInvestmentCategoryError = createAction('DELETE_INVESTMENT_CATEGORY_ERROR');

/*Add Investment Sub Category Action */
const addInvestmentSubCategoryRequest = createAction('ADD_INVESTMENT_SUB_CATEGORY_REQUEST', data => data);
const addInvestmentSubCategorySuccess = createAction('ADD_INVESTMENT_SUB_CATEGORY_SUCCESS', data => data);
const addInvestmentSubCategoryError = createAction('ADD_INVESTMENT_SUB_CATEGORY_ERROR');

/*Update Investment Sub Category Action */
const updateInvestmentSubCategoryRequest = createAction('UPDATE_INVESTMENT_SUB_CATEGORY_REQUEST', data => data);
const updateInvestmentSubCategorySuccess = createAction('UPDATE_INVESTMENT_SUB_CATEGORY_SUCCESS', data => data);
const updateInvestmentSubCategoryError = createAction('UPDATE_INVESTMENT_SUB_CATEGORY_ERROR');

/*Get Investment Sub Category Action */
const getInvestmentSubCategoryRequest = createAction('GET_INVESTMENT_SUB_CATEGORY_REQUEST', data => data);
const getInvestmentSubCategorySuccess = createAction('GET_INVESTMENT_SUB_CATEGORY_SUCCESS', data => data);
const getInvestmentSubCategoryError = createAction('GET_INVESTMENT_SUB_CATEGORY_ERROR');

/*Get Investment Sub Category Action */
const getAllInvestmentSubCategoryRequest = createAction('GET_ALL_INVESTMENT_SUB_CATEGORY_REQUEST', data => data);
const getAllInvestmentSubCategorySuccess = createAction('GET_ALL_INVESTMENT_SUB_CATEGORY_SUCCESS', data => data);
const getAllInvestmentSubCategoryError = createAction('GET_ALL_INVESTMENT_SUB_CATEGORY_ERROR');

/*Get Investment Sub Category Action */
const deleteInvestmentSubCategoryRequest = createAction('DELETE_INVESTMENT_SUB_CATEGORY_REQUEST', data => data);
const deleteInvestmentSubCategorySuccess = createAction('DELETE_INVESTMENT_SUB_CATEGORY_SUCCESS', data => data);
const deleteInvestmentSubCategoryError = createAction('DELETE_INVESTMENT_SUB_CATEGORY_ERROR');

/*Get Investment Sub Category Action */
const getAllInvestmentCategoryDetailsRequest = createAction('GET_ALL_INVESTMENT_CATEGORY_DETAILS_REQUEST', data => data);
const getAllInvestmentCategoryDetailsSuccess = createAction('GET_ALL_INVESTMENT_CATEGORY_DETAILS_SUCCESS', data => data);
const getAllInvestmentCategoryDetailsError = createAction('GET_ALL_INVESTMENT_CATEGORY_DETAILS_ERROR');


/*add Loans action */
const addLoansRequest = createAction('ADD_LOANS_REQUEST', data => data);
const addLoansSuccess = createAction('ADD_LOANS_SUCCESS', data => data);
const addLoansError = createAction('ADD_LOANS_ERROR');

/*update Loans action */
const updateLoansRequest = createAction('UPDATE_LOANS_REQUEST', data => data);
const updateLoansSuccess = createAction('UPDATE_LOANS_SUCCESS', data => data);
const updateLoansError = createAction('UPDATE_LOANS_ERROR');

/*Get Loans action */
const getLoansRequest = createAction('GET_LOANS_REQUEST', data => data);
const getLoansSuccess = createAction('GET_LOANS_SUCCESS', data => data);
const getLoansError = createAction('GET_LOANS_ERROR');

/*Get apply Advance action */
const applyAdvanceRequest = createAction('APPLY_ADVANCE_REQUEST', data => data);
const applyAdvanceSuccess = createAction('APPLY_ADVANCE_SUCCESS', data => data);
const applyAdvanceError = createAction('APPLY_ADVANCE_ERROR');

/*Get Advance Approval action */
const getAdvanceApprovalRequest = createAction('GET_ADVANCE_APPROVAL_REQUEST', data => data);
const getAdvanceApprovalSuccess = createAction('GET_ADVANCE_APPROVAL_SUCCESS', data => data);
const getAdvanceApprovalError = createAction('GET_ADVANCE_APPROVAL_ERROR');

/*Get Advance Request action */
const getAdvanceRequestRequest = createAction('GET_ADVANCE_REQUEST_REQUEST', data => data);
const getAdvanceRequestSuccess = createAction('GET_ADVANCE_REQUEST_SUCCESS', data => data);
const getAdvanceRequestError = createAction('GET_ADVANCE_REQUEST_ERROR');

/*Approval Reject Advance action */
const approvalRejectAdvanceRequest = createAction('APPROVAL_REJECT_ADVANCE_REQUEST', data => data);
const approvalRejectAdvanceSuccess = createAction('APPROVAL_REJECT_ADVANCE_SUCCESS', data => data);
const approvalRejectAdvanceError = createAction('APPROVAL_REJECT_ADVANCE_ERROR');

/*employee Investment Proof action */
const employeeInvestmentProofRequest = createAction('EMPLOYEE_INVESTMENT_PROOF_REQUEST', data => data);
const employeeInvestmentProofSuccess = createAction('EMPLOYEE_INVESTMENT_PROOF_SUCCESS', data => data);
const employeeInvestmentProofError = createAction('EMPLOYEE_INVESTMENT_PROOF_ERROR');

/*get employee Investment Proof action */
const getEmployeeInvestmentProofRequest = createAction('GET_EMPLOYEE_INVESTMENT_PROOF_REQUEST', data => data);
const getEmployeeInvestmentProofSuccess = createAction('GET_EMPLOYEE_INVESTMENT_PROOF_SUCCESS', data => data);
const getEmployeeInvestmentProofError = createAction('GET_EMPLOYEE_INVESTMENT_PROOF_ERROR');

/*update employee Investment Proof action */
const updateEmployeeInvestmentProofRequest = createAction('UPDATE_EMPLOYEE_INVESTMENT_PROOF_REQUEST', data => data);
const updateEmployeeInvestmentProofSuccess = createAction('UPDATE_EMPLOYEE_INVESTMENT_PROOF_SUCCESS', data => data);
const updateEmployeeInvestmentProofError = createAction('UPDATE_EMPLOYEE_INVESTMENT_PROOF_ERROR');

/*Delete employee Investment Proof action */
const deleteEmployeeInvestmentProofRequest = createAction('DELETE_EMPLOYEE_INVESTMENT_PROOF_REQUEST', data => data);
const deleteEmployeeInvestmentProofSuccess = createAction('DELETE_EMPLOYEE_INVESTMENT_PROOF_SUCCESS', data => data);
const deleteEmployeeInvestmentProofError = createAction('DELETE_EMPLOYEE_INVESTMENT_PROOF_ERROR');

/*Delete employee Investment Proof action */
const commentInEmployeeInvestmentProofRequest = createAction('COMMENT_IN_EMPLOYEE_INVESTMENT_PROOF_REQUEST', data => data);
const commentInEmployeeInvestmentProofSuccess = createAction('COMMENT_IN_EMPLOYEE_INVESTMENT_PROOF_SUCCESS', data => data);
const commentInEmployeeInvestmentProofError = createAction('COMMENT_IN_EMPLOYEE_INVESTMENT_PROOF_ERROR');

/*get all employee salary employee id wise action */
const getAllEmployeeSalaryRequest = createAction('GET_ALL_EMPLOYEE_SALARY_REQUEST', data => data);
const getAllEmployeeSalarySuccess = createAction('GET_ALL_EMPLOYEE_SALARY_SUCCESS', data => data);
const getAllEmployeeSalaryError = createAction('GET_ALL_EMPLOYEE_SALARY_ERROR');

/* Check Rule Formula action */
const getEmployeeMonthlySalaryRequest = createAction('GET_EMPLOYEE_MONTHLY_SALARY_REQUEST', data => data);
const getEmployeeMonthlySalarySuccess = createAction('GET_EMPLOYEE_MONTHLY_SALARY_SUCCESS', data => data);
const getEmployeeMonthlySalaryError = createAction('GET_EMPLOYEE_MONTHLY_SALARY_ERROR');

/* Generate Salary Slip action */
const generateSalarySlipRequest = createAction('GENERATE_SALARY_SLIP_REQUEST', data => data);
const generateSalarySlipSuccess = createAction('GENERATE_SALARY_SLIP_SUCCESS', data => data);
const generateSalarySlipError = createAction('GENERATE_SALARY_SLIP_ERROR');

/* Send Offer Letter action */
const sendOfferLetterRequest = createAction('SEND_OFFER_LETTER_REQUEST', data => data);
const sendOfferLetterSuccess = createAction('SEND_OFFER_LETTER_SUCCESS', data => data);
const sendOfferLetterError = createAction('SEND_OFFER_LETTER_ERROR');



/* Check Rule Formula action */
const checkRuleFormulaRequest = createAction('CHECK_RULE_FORMULA_REQUEST', data => data);
const checkRuleFormulaSuccess = createAction('CHECK_RULE_FORMULA_SUCCESS', data => data);
const checkRuleFormulaError = createAction('CHECK_RULE_FORMULA_ERROR');

/* Check Rule Formula action */
const getCandidateSalaryRequest = createAction('GET_CANDIDATE_SALARY_REQUEST', data => data);
const getCandidateSalarySuccess = createAction('GET_CANDIDATE_SALARY_SUCCESS', data => data);
const getCandidateSalaryError = createAction('GET_CANDIDATE_SALARY_ERROR');

/* Check Rule Formula action */
const updateEmployeeMonthlySalaryRequest = createAction('UPDATE_EMPLOYEE_MONTHLY_SALARY_REQUEST', data => data);
const updateEmployeeMonthlySalarySuccess = createAction('UPDATE_EMPLOYEE_MONTHLY_SALARY_SUCCESS', data => data);
const updateEmployeeMonthlySalaryError = createAction('UPDATE_EMPLOYEE_MONTHLY_SALARY_ERROR');

const deleteEarningTypeRequest = createAction('DELETE_EARNING_TYPE_REQUEST', data => data);
const deleteEarningTypeSuccess = createAction('DELETE_EARNING_TYPE_SUCCESS', data => data);
const deleteEarningTypeError = createAction('DELETE_EARNING_TYPE_ERROR');

const deleteDeductionTypeRequest = createAction('DELETE_DEDUCTION_TYPE_REQUEST', data => data);
const deleteDeductionTypeSuccess = createAction('DELETE_DEDUCTION_TYPE_SUCCESS', data => data);
const deleteDeductionTypeError = createAction('DELETE_DEDUCTION_TYPE_ERROR');


const deleteEarningRequest = createAction('DELETE_EARNING_REQUEST', data => data);
const deleteEarningSuccess = createAction('DELETE_EARNING_SUCCESS', data => data);
const deleteEarningError = createAction('DELETE_EARNING_ERROR');

const deleteDeductionRequest = createAction('DELETE_DEDUCTION_REQUEST', data => data);
const deleteDeductionSuccess = createAction('DELETE_DEDUCTION_SUCCESS', data => data);
const deleteDeductionError = createAction('DELETE_DEDUCTION_ERROR');

const deleteSalaryTemplateRequest = createAction('DELETE_SALARY_TEMPLATE_REQUEST', data => data);
const deleteSalaryTemplateSuccess = createAction('DELETE_SALARY_TEMPLATE_SUCCESS', data => data);
const deleteSalaryTemplateError = createAction('DELETE_SALARY_TEMPLATE_ERROR');

const getEmployeeMonthlyPaySlipRequest = createAction('GET_EMPLOYEE_MONTHLY_PAY_SLIP_REQUEST', data => data);
const getEmployeeMonthlyPaySlipSuccess = createAction('GET_EMPLOYEE_MONTHLY_PAY_SLIP_SUCCESS', data => data);
const getEmployeeMonthlyPaySlipError = createAction('GET_EMPLOYEE_MONTHLY_PAY_SLIP_ERROR');

const selectedEmployeeData = createAction('SELECTED_EMPLOYEE_DATA', data => data);
const actionTypeRequest = createAction('ACTION_TYPE', data => data);
// clear existing Department action
const handleClearPayrollStore = createAction('HANDLE_CLEAR_PAYROLL_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    getEmployeeDetailsByPayDaysRequest,
    getEmployeeDetailsByPayDaysSuccess,
    getEmployeeDetailsByPayDaysError,

    getAttendanceStatusRequest,
    getAttendanceStatusSuccess,
    getAttendanceStatusError,

    updateAttendanceTrackingRequest,
    updateAttendanceTrackingSuccess,
    updateAttendanceTrackingError,

    addEarningsRequest,
    addEarningsSuccess,
    addEarningsError,

    updateEarningsRequest,
    updateEarningsSuccess,
    updateEarningsError,

    getEarningsRequest,
    getEarningsSuccess,
    getEarningsError,

    addDeductionsRequest,
    addDeductionsSuccess,
    addDeductionsError,

    updateDeductionsRequest,
    updateDeductionsSuccess,
    updateDeductionsError,

    getDeductionsRequest,
    getDeductionsSuccess,
    getDeductionsError,

    addTaxSlabsRequest,
    addTaxSlabsSuccess,
    addTaxSlabsError,

    addEarningTypesRequest,
    addEarningTypesSuccess,
    addEarningTypesError,

    updateEarningTypesRequest,
    updateEarningTypesSuccess,
    updateEarningTypesError,

    getEarningTypeRequest,
    getEarningTypeSuccess,
    getEarningTypeError,

    getAllEarningTypeRequest,
    getAllEarningTypeSuccess,
    getAllEarningTypeError,

    getEarningTypeByIdRequest,
    getEarningTypeByIdSuccess,
    getEarningTypeByIdError,

    addDeductionTypesRequest,
    addDeductionTypesSuccess,
    addDeductionTypesError,

    updateDeductionTypesRequest,
    updateDeductionTypesSuccess,
    updateDeductionTypesError,

    getDeductionTypeRequest,
    getDeductionTypeSuccess,
    getDeductionTypeError,

    getAllDeductionTypeRequest,
    getAllDeductionTypeSuccess,
    getAllDeductionTypeError,

    getDeductionTypeByIdRequest,
    getDeductionTypeByIdSuccess,
    getDeductionTypeByIdError,

    generateSalaryTemplateRequest,
    generateSalaryTemplateSuccess,
    generateSalaryTemplateError,

    saveSalaryTemplateRequest,
    saveSalaryTemplateSuccess,
    saveSalaryTemplateError,

    getAllSalaryTemplateRequest,
    getAllSalaryTemplateSuccess,
    getAllSalaryTemplateError,

    getSalaryTemplateRequest,
    getSalaryTemplateSuccess,
    getSalaryTemplateError,

    updateSalaryTemplateRequest,
    updateSalaryTemplateSuccess,
    updateSalaryTemplateError,

    getSalaryTemplateByIdRequest,
    getSalaryTemplateByIdSuccess,
    getSalaryTemplateByIdError,

    getAllEarningRequest,
    getAllEarningSuccess,
    getAllEarningError,

    getAllDeductionRequest,
    getAllDeductionSuccess,
    getAllDeductionError,

    calculateCtcRequest,
    calculateCtcSuccess,
    calculateCtcError,

    addArrearsRequest,
    addArrearsSuccess,
    addArrearsError,

    getArrearsRequest,
    getArrearsSuccess,
    getArrearsError,

    addEmployeeSalaryRequest,
    addEmployeeSalarySuccess,
    addEmployeeSalaryError,

    getEmployeeSalaryRequest,
    getEmployeeSalarySuccess,
    getEmployeeSalaryError,

    updateEmployeeSalaryRequest,
    updateEmployeeSalarySuccess,
    updateEmployeeSalaryError,

    getAllEmployeeAssignStatusRequest,
    getAllEmployeeAssignStatusSuccess,
    getAllEmployeeAssignStatusError,

    addPayRunRequest,
    addPayRunSuccess,
    addPayRunError,

    addPayScheduleRequest,
    addPayScheduleSuccess,
    addPayScheduleError,

    updatePayScheduleRequest,
    updatePayScheduleSuccess,
    updatePayScheduleError,

    upcomingPayrollsRequest,
    upcomingPayrollsSuccess,
    upcomingPayrollsError,

    payRollNotificationRequest,
    payRollNotificationSuccess,
    payRollNotificationError,

    getPayRunRequest,
    getPayRunSuccess,
    getPayRunError,

    getPayRunDashboardDataRequest,
    getPayRunDashboardDataSuccess,
    getPayRunDashboardDataError,

    getPayRunHistoryRequest,
    getPayRunHistorySuccess,
    getPayRunHistoryError,

    approvePayrollRequest,
    approvePayrollSuccess,
    approvePayrollError,

    addTaxSlabRequest,
    addTaxSlabSuccess,
    addTaxSlabError,

    updateTaxSlabRequest,
    updateTaxSlabSuccess,
    updateTaxSlabError,

    getTaxSlabRequest,
    getTaxSlabSuccess,
    getTaxSlabError,

    getAllTaxSlabRequest,
    getAllTaxSlabSuccess,
    getAllTaxSlabError,

    deleteTaxSlabRequest,
    deleteTaxSlabSuccess,
    deleteTaxSlabError,

    addEmployeeInvestmentRequest,
    addEmployeeInvestmentSuccess,
    addEmployeeInvestmentError,

    getEmployeeInvestmentRequest,
    getEmployeeInvestmentSuccess,
    getEmployeeInvestmentError,

    updateEmployeeInvestmentRequest,
    updateEmployeeInvestmentSuccess,
    updateEmployeeInvestmentError,

    deleteEmployeeInvestmentRequest,
    deleteEmployeeInvestmentSuccess,
    deleteEmployeeInvestmentError,

    addInvestmentCategoryRequest,
    addInvestmentCategorySuccess,
    addInvestmentCategoryError,

    updateInvestmentCategoryRequest,
    updateInvestmentCategorySuccess,
    updateInvestmentCategoryError,

    getInvestmentCategoryRequest,
    getInvestmentCategorySuccess,
    getInvestmentCategoryError,

    getAllInvestmentCategoryRequest,
    getAllInvestmentCategorySuccess,
    getAllInvestmentCategoryError,

    deleteInvestmentCategoryRequest,
    deleteInvestmentCategorySuccess,
    deleteInvestmentCategoryError,

    addInvestmentSubCategoryRequest,
    addInvestmentSubCategorySuccess,
    addInvestmentSubCategoryError,

    updateInvestmentSubCategoryRequest,
    updateInvestmentSubCategorySuccess,
    updateInvestmentSubCategoryError,

    getInvestmentSubCategoryRequest,
    getInvestmentSubCategorySuccess,
    getInvestmentSubCategoryError,

    getAllInvestmentSubCategoryRequest,
    getAllInvestmentSubCategorySuccess,
    getAllInvestmentSubCategoryError,

    deleteInvestmentSubCategoryRequest,
    deleteInvestmentSubCategorySuccess,
    deleteInvestmentSubCategoryError,

    getAllInvestmentCategoryDetailsRequest,
    getAllInvestmentCategoryDetailsSuccess,
    getAllInvestmentCategoryDetailsError,

    addLoansRequest,
    addLoansSuccess,
    addLoansError,

    updateLoansRequest,
    updateLoansSuccess,
    updateLoansError,

    getLoansRequest,
    getLoansSuccess,
    getLoansError,


    getLoansRequest,
    getLoansSuccess,
    getLoansError,

    applyAdvanceRequest,
    applyAdvanceSuccess,
    applyAdvanceError,

    getAdvanceApprovalRequest,
    getAdvanceApprovalSuccess,
    getAdvanceApprovalError,

    getAdvanceRequestRequest,
    getAdvanceRequestSuccess,
    getAdvanceRequestError,

    approvalRejectAdvanceRequest,
    approvalRejectAdvanceSuccess,
    approvalRejectAdvanceError,

    checkRuleFormulaRequest,
    checkRuleFormulaSuccess,
    checkRuleFormulaError,

    employeeInvestmentProofRequest,
    employeeInvestmentProofSuccess,
    employeeInvestmentProofError,

    getEmployeeInvestmentProofRequest,
    getEmployeeInvestmentProofSuccess,
    getEmployeeInvestmentProofError,

    updateEmployeeInvestmentProofRequest,
    updateEmployeeInvestmentProofSuccess,
    updateEmployeeInvestmentProofError,

    deleteEmployeeInvestmentProofRequest,
    deleteEmployeeInvestmentProofSuccess,
    deleteEmployeeInvestmentProofError,

    commentInEmployeeInvestmentProofRequest,
    commentInEmployeeInvestmentProofSuccess,
    commentInEmployeeInvestmentProofError,

    getAllEmployeeSalaryRequest,
    getAllEmployeeSalarySuccess,
    getAllEmployeeSalaryError,

    getEmployeeMonthlySalaryRequest,
    getEmployeeMonthlySalarySuccess,
    getEmployeeMonthlySalaryError,

    generateSalarySlipRequest,
    generateSalarySlipSuccess,
    generateSalarySlipError,

    sendOfferLetterRequest,
    sendOfferLetterSuccess,
    sendOfferLetterError,

    getCandidateSalaryRequest,
    getCandidateSalarySuccess,
    getCandidateSalaryError,

    updateEmployeeMonthlySalaryRequest,
    updateEmployeeMonthlySalarySuccess,
    updateEmployeeMonthlySalaryError,

    deleteEarningTypeRequest,
    deleteEarningTypeSuccess,
    deleteEarningTypeError,

    deleteDeductionTypeRequest,
    deleteDeductionTypeSuccess,
    deleteDeductionTypeError,

    deleteEarningRequest,
    deleteEarningSuccess,
    deleteEarningError,

    deleteDeductionRequest,
    deleteDeductionSuccess,
    deleteDeductionError,

    deleteSalaryTemplateRequest,
    deleteSalaryTemplateSuccess,
    deleteSalaryTemplateError,
    
    getEmployeeMonthlyPaySlipRequest,
    getEmployeeMonthlyPaySlipSuccess,
    getEmployeeMonthlyPaySlipError,

    selectedEmployeeData,
    actionTypeRequest,
    handleClearPayrollStore,

}